import { get, patch } from "../axiosUitils";

const basePath = "/city_collab/member-profile";

export interface MemberProfileResponse {
  id?: string;
  first_name?: string;
  last_name?: string;
  organization?: string;
  committee_count?: number;
  regional_connections?: number;
  sops_owned?: number;
  compliance?: number;
  email?: string;
  address?: string;
  created_on?: string;
  profilephoto?: string | null;
  [key: string]: any; // Allow for additional fields
}

export interface UpdateMemberProfilePayload {
  first_name?: string;
  last_name?: string;
  email?: string;
}

class MemberProfileService {
  /**
   * Get member profile
   */
  getMemberProfile = async (): Promise<MemberProfileResponse> => {
    const response = await get<any>(`${basePath}/`);

    if (response?.data && Array.isArray(response.data)) {
      return response.data[0] || {};
    } else if (Array.isArray(response)) {
      return response[0] || {};
    } else if (response?.data) {
      return response.data;
    }

    return response || {};
  };

  /**
   * Update member profile
   */
  updateMemberProfile = async (
    payload: UpdateMemberProfilePayload
  ): Promise<MemberProfileResponse> => {
    const response = await patch<MemberProfileResponse>(
      `${basePath}/`,
      payload
    );

    return response;
  };

  /**
   * Get government skills
   */
  getGovSkills = async (): Promise<any[]> => {
    const response = await get<any>(`${basePath}/gov-skills/`);
    // Handle nested response structure with data field
    if (response?.data && Array.isArray(response.data)) {
      return response.data;
    }
    // Fallback if response is directly an array
    if (Array.isArray(response)) {
      return response;
    }
    return [];
  };
}

const instance = new MemberProfileService();
export default instance;
